import Persona from "components/persona/Persona";
import { MessageItem } from "models/inbox/inbox";

import { splitName } from "common/splitName/splitName";
import { useCleanBody } from "hooks/use-clean-body";

import { format, isAfter, subHours } from "date-fns";
import { sv } from "date-fns/locale";

import { Attach16Regular } from "@fluentui/react-icons";
import "../index.scss";

type Props = {
  message: MessageItem;
  isActive: boolean;
  onSelect: (e: React.MouseEvent) => void;
};

export default function MessageSidebarItem({
  message,
  isActive,
  onSelect
}: Props) {
  const { formatedFrom, createdAt, body, attachments } = message;

  const sender = splitName(formatedFrom);

  const yesterday = subHours(new Date(), 24);
  const messageDate = new Date(createdAt);
  const isRecent = isAfter(messageDate, yesterday);

  const displayDate = isRecent
    ? format(messageDate, "HH:mm")
    : format(messageDate, "yyyy/MM/dd", { locale: sv });

  const cleanedBody = useCleanBody(body) || "...";

  return (
    <div
      className={`sidebar-item d-flex align-items-start sidebar-item-sent-message ${isActive ? "sidebar-item-active" : ""}`}
      onClick={onSelect}
    >
      <Persona
        firstName={sender.firstName}
        lastName={sender.lastName}
        className="mr-3 mt-2 message-person"
      />

      <div className="d-flex flex-direction-column w-100">
        <div className="d-flex justify-content-between mt-1">
          <div>
            <span className="mr-3 message-sender">{formatedFrom}</span>
          </div>

          <div className="d-flex align-items-center gap-2">
            {attachments && attachments.length > 0 && <Attach16Regular />}
            <div className="message-time fw-normal">{displayDate}</div>
          </div>
        </div>

        <div className="thread-message fw-normal message-content html-editor html-editor-truncate-text">
          {cleanedBody}
        </div>
      </div>
    </div>
  );
}
